import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import store from './_redux/store';

import { BrowserRouter } from 'react-router-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';

import TagManager from 'react-gtm-module';

const tagManagerArgs = {
	//	gtmId: 'GTM-KGG5NJS' //QA
	//gtmId: 'GTM-W642D5X'
	gtmId: process.env.GTM
};

TagManager.initialize(tagManagerArgs);

let app = (
	<Provider store={store}>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</Provider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
